import '@vfde-brix/timeline-stepper/dist/styles.css';
import { createTimelineStepperComponent } from '@vfde-brix/timeline-stepper';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-timeline-stepper', createTimelineStepperComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);
